/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDetailShipsFrom_item = {
    readonly address: {
        readonly itemAddress: string | null;
    } | null;
    readonly " $refType": "PdpSharedDetailShipsFrom_item";
};
export type PdpSharedDetailShipsFrom_item$data = PdpSharedDetailShipsFrom_item;
export type PdpSharedDetailShipsFrom_item$key = {
    readonly " $data"?: PdpSharedDetailShipsFrom_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipsFrom_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipsFrom_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": "itemAddress",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a30dcf2c93a14e834f0b5af680f91c0c';
export default node;
